import type { IconData } from '@stacksjs/iconify-core'

export const layoutRightSidebarSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 43.5q2.404 0 4.5-.016V4.517A594 594 0 0 0 24 4.5c-7.196 0-12.277.12-15.598.242c-3.67.136-6.562 3.001-6.7 6.683C1.594 14.25 1.5 18.359 1.5 24s.095 9.75.201 12.576c.139 3.68 3.031 6.546 6.701 6.682c3.321.122 8.402.242 15.598.242M39.597 4.742a348 348 0 0 0-8.097-.194v38.904c3.404-.046 6.077-.12 8.097-.194c3.67-.136 6.563-3.001 6.702-6.682c.106-2.826.201-6.935.201-12.576c0-5.64-.095-9.75-.201-12.575c-.139-3.682-3.031-6.547-6.702-6.683M40 10.5a1.5 1.5 0 0 1 0 3h-3a1.5 1.5 0 0 1 0-3zm1.5 8.5a1.5 1.5 0 0 0-1.5-1.5h-3a1.5 1.5 0 0 0 0 3h3a1.5 1.5 0 0 0 1.5-1.5M40 24.5a1.5 1.5 0 0 1 0 3h-3a1.5 1.5 0 0 1 0-3z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default layoutRightSidebarSolid
